<template>
  <div class="main main-page">
    <div class="item" @click="toForDate">
      <div class="title">按时间</div>
      <div class="checkMore">
        <img src="@/assets/image/right.png" width="15px" height="15px" alt="" />
      </div>
    </div>
    <div class="item" @click="toForClassRoom">
      <div class="title">按教室</div>
      <img src="@/assets/image/right.png" width="15px" height="15px" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toForClassRoom() {
      this.$router.push({ name: "classroomQueryForClassRoom" });
    },
    toForDate() {
      this.$router.push({ name: "classroomQueryForDate" });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding: 14px 16px;
  .item {
    position: relative;
    padding: 16px;
    border-radius: 7px;
    background-color: rgb(248, 248, 248);
    margin-bottom: 10px;
    img {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .title {
    font-size: 12px;
    font-weight: 900;
    color: rgb(51, 51, 51);
  }
}
</style>
